import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize, takeUntil } from 'rxjs';
import { BaseComponent } from '../../../base.component';
import { Category } from '../../../models/category.model';
import { CriterionsService } from '../../../services/criterions.service';

@Component({
  selector: 'app-criteria-preview',
  templateUrl: './criteria-preview.component.html',
  styleUrls: ['./criteria-preview.component.scss']
})
export class CriteriaPreviewComponent extends BaseComponent implements OnInit {
  isLoadingResults = false;
  category$: Observable<Category>;

  constructor(private criterionsService: CriterionsService) { super(); }

  ngOnInit(): void {
    this.criterionsService.criterion$
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.getCategory(data.submissionId);
      });
  }

  private getCategory(criterionId: string) {
    this.isLoadingResults = true;
    this.category$ = this.criterionsService.getCategory(criterionId)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.isLoadingResults = false;
        })
      );
  }

}
